<div class="page-surface-header" [ngClass]="compact ? 'mb-2' : 'mb-4'">
    <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <div class="flex min-w-0 items-center gap-2.5">
            <!-- One chip, many glyphs: the wrapper was repeated per icon, which is how the agent
                 page ended up with a yellow badge nobody else had. -->
            <span
                *ngIf="titleIcon"
                class="flex size-9 shrink-0 items-center justify-center rounded-xl bg-gray-100 text-[#18214d] dark:bg-white/10 dark:text-white"
                aria-hidden="true"
            >
                <ng-container [ngSwitch]="titleIcon">
                    <icon-layout-grid *ngSwitchCase="'dashboard'" class="size-5" />
                    <icon-cpu-bolt *ngSwitchCase="'cpu-bolt'" class="size-5" />
                    <icon-users *ngSwitchCase="'users'" class="size-5" />
                    <icon-user *ngSwitchCase="'user'" class="size-5" />
                    <icon-users-group *ngSwitchCase="'clients'" class="size-5" />
                    <icon-menu-charts *ngSwitchCase="'chart'" class="size-5" />
                    <icon-clipboard-text *ngSwitchCase="'clipboard'" class="size-5" />
                    <icon-share *ngSwitchCase="'workflow'" class="size-5" />
                    <icon-dollar-sign-circle *ngSwitchCase="'billing'" class="size-5" />
                    <icon-credit-card *ngSwitchCase="'card'" class="size-5" />
                    <icon-bell-bing *ngSwitchCase="'bell'" class="size-5" />
                    <icon-clock *ngSwitchCase="'clock'" class="size-5" />
                    <icon-lock *ngSwitchCase="'lock'" class="size-5" />
                    <icon-globe *ngSwitchCase="'globe'" class="size-5" />
                    <icon-file *ngSwitchCase="'file'" class="size-5" />
                    <icon-notes *ngSwitchCase="'notes'" class="size-5" />
                    <icon-link *ngSwitchCase="'link'" class="size-5" />
                    <icon-settings *ngSwitchCase="'settings'" class="size-5" />
                    <icon-server *ngSwitchCase="'server'" class="size-5" />
                    <icon-heart *ngSwitchCase="'heart'" class="size-5" />
                    <icon-square-check *ngSwitchCase="'checks'" class="size-5" />
                </ng-container>
            </span>
            <h1 class="min-w-0 text-2xl font-normal text-[#18214d] duration-300 dark:text-white md:text-[22px]">
                {{ title }}
            </h1>
        </div>
        <div class="flex shrink-0 flex-wrap items-center justify-end gap-2">
            <div
                *ngIf="tabs.length"
                class="flex flex-wrap gap-2"
                role="tablist"
                [attr.aria-label]="ariaTablistLabel"
            >
                <button
                    *ngFor="let tab of tabs; trackBy: trackTabKey"
                    type="button"
                    role="tab"
                    [attr.aria-selected]="activeTabKey === tab.key"
                    class="flex items-center rounded-full px-4 py-2 text-sm font-medium transition-colors"
                    [ngClass]="
                        activeTabKey === tab.key
                            ? 'bg-[#FFD85F] text-black shadow-sm dark:bg-[#e8c44a] dark:text-black'
                            : 'border border-gray-200 bg-white text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-gray-200 dark:hover:bg-white/5'
                    "
                    (click)="selectTab(tab.key)"
                >
                    {{ tab.label }}
                </button>
            </div>
            <!-- Flex, not a block: projected actions were inline-level boxes aligned on the text
                 baseline, and an inline-flex button takes its baseline from its first child — so a
                 button starting with an icon sat lower than one starting with text. Any page
                 projecting two actions had them off by a few pixels. -->
            <div class="flex flex-wrap items-center gap-2 [&:empty]:hidden">
                <ng-content select="[pageHeaderActions]"></ng-content>
            </div>
        </div>
    </div>
    <p *ngIf="subtitle" class="mt-1 max-w-3xl text-sm text-gray-500 dark:text-gray-400">{{ subtitle }}</p>
</div>
